var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "WorkFlowSandbox" } }, [
    _c("div", { staticClass: "header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "header-text" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("task.workflowSandbox.title")))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("task.workflowSandbox.description")))]),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c(
          "div",
          { staticClass: "workflows-loading" },
          _vm._l(3, function (skltn) {
            return _c(
              "div",
              { key: skltn, staticClass: "workflow workflow-skeleton" },
              [
                _c("a-skeleton", {
                  attrs: { active: true, paragraph: { rows: 3 } },
                }),
              ],
              1
            )
          }),
          0
        )
      : _vm.deletedWorkflows.length === 0
      ? _c("div", { staticClass: "empty-state" }, [
          _c("i", { staticClass: "material-icons" }, [
            _vm._v("delete_outline"),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("task.workflowSandbox.emptyState")))]),
        ])
      : _c(
          "div",
          { staticClass: "workflows" },
          _vm._l(_vm.deletedWorkflows, function (workflow) {
            return _c(
              "div",
              {
                key: workflow._id || workflow.id,
                staticClass: "workflow workflow-deleted",
              },
              [
                _c(
                  "div",
                  { staticClass: "workflow-header" },
                  [
                    _c("div", { staticClass: "workflow-title" }, [
                      _vm._v(
                        _vm._s(
                          workflow.title ||
                            _vm.$t("task.workflowSandbox.unnamedWorkflow")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-popover",
                      {
                        staticClass: "workflow-menu-content",
                        attrs: { trigger: "click" },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "workflow-menu-popover-items",
                                on: {
                                  click: function ($event) {
                                    return _vm.restoreWorkflow(workflow)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _c("a-icon", {
                                      staticClass: "px-1",
                                      attrs: { type: "undo" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("task.workflowSandbox.restore")
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "workflow-menu-popover-items workflow-menu-popover-items-danger",
                                on: {
                                  click: function ($event) {
                                    return _vm.permanentlyDeleteWorkflow(
                                      workflow
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _c("a-icon", {
                                      staticClass: "px-1",
                                      attrs: { type: "delete" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "task.workflowSandbox.permanentlyDelete"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            staticClass: "workflow-menu-btn",
                            on: {
                              click: function (e) {
                                return e.stopPropagation()
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("more_vert"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "workflow-content" }, [
                  workflow.description
                    ? _c("div", { staticClass: "workflow-description" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(workflow.description) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "workflow-meta" }, [
                    _c("div", { staticClass: "meta-item" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("schedule"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.formatDeletedDate(workflow.trashedAt))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    workflow.trashedBy
                      ? _c("div", { staticClass: "meta-item" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("person"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.getDeletedByText(workflow.trashedBy))
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("delete_outline")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }